import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedConfigurators = createPaginatedSlice('paginatedConfigurators');

export const paginatedConfiguratorsActions = paginatedConfigurators.actions;
export const paginatedConfiguratorsSelector = (state) => state.paginatedConfigurators;
export const paginatedConfiguratorsReducer = paginatedConfigurators.reducer;
export default paginatedConfiguratorsReducer;

export const paginatedConfiguratorsSelectors = paginatedConfigurators.LF.selectors;
